import Vue from 'vue';

Vue.directive('lowercase', {
  inserted: function (el, _, vnode) {
    el.addEventListener('input', async function (e) {
      e.target.value = e.target.value.toLowerCase();
      vnode.componentInstance.$emit('input', e.target.value.toLowerCase());
    });
  },
});

Vue.directive('dynamic-events', {
  bind(el, binding, vnode) {
    const events = binding.value;
    if (events && typeof events === 'object') {
      Object.keys(events).forEach(eventName => {
        vnode.componentInstance.$on(eventName, events[eventName]);
      });
    }
  },
  unbind(el, binding, vnode) {
    const events = binding.value;
    if (events && typeof events === 'object') {
      Object.keys(events).forEach(eventName => {
        vnode.componentInstance.$off(eventName, events[eventName]);
      });
    }
  },
});
